import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const ApprovalBlogCard = ({ title, excerpt, image, author, date, readMoreLink }) => {
    useEffect(() => {
        AOS.init({
            duration: 1000, // Animation duration in milliseconds
            once: true, // Animation should happen only once
        });
    }, []);

    return (
        <div 
            data-aos="fade-up" 
            className="w-full h-full flex flex-col bg-white p-6 rounded-lg shadow-lg hover:shadow-2xl transition-shadow"
        >
            {/* Blog image with increased height */}
            <div className="w-full h-auto max-h-[650px] overflow-hidden rounded-md mb-4">
                <img
                    src={image}
                    alt={title}
                    className="w-full h-auto object-cover rounded-md"
                />
            </div>

            {/* Blog title */}
            <h3 className="text-2xl font-bold text-gray-800 mb-2 flex-grow">{title}</h3>

            {/* Blog author and date */}
            <div className="text-gray-600 mb-4">
                <p>By <span className="font-semibold">{author}</span></p>
                <p className="text-sm">{date}</p>
            </div>

            {/* Blog excerpt */}
            <p className="text-gray-600 mb-4 flex-grow">{excerpt}</p>

            {/* Read more button */}
            <a
                href={readMoreLink}
                className="mt-auto inline-block bg-purple-700 text-white py-3 px-6 rounded-lg hover:bg-purple-800 transition-colors text-center"
            >
                Read More
            </a>
        </div>
    );
};

export default ApprovalBlogCard;
